if (typeof ProductQuantity !== 'function') {

  class ProductQuantity extends HTMLElement {

    constructor() {
      super();

      const qty      = this.querySelector('.qty-selector'),
            qtyMinus = this.querySelector('.qty-minus'),
            qtyPlus  = this.querySelector('.qty-plus'),
            qtyMin   = 1,
            qtyMax   = 999;

      // If this instance doesn't have the expected controls (e.g. boxed wine template),
      // exit early so we don't throw errors.
      if (!qty || !qtyMinus || !qtyPlus) {
        console.warn('ProductQuantity: missing qty elements on this instance, skipping.');
        return;
      }

      const currentVal = parseInt(qty.value, 10) || 1;

      // Initial button disable state
      if (currentVal <= qtyMin) {
        qtyMinus.classList.add('disabled');
      }
      if (currentVal >= qtyMax) {
        qtyPlus.classList.add('disabled');
      }

      /**
       * Syncs the local qty input with the hidden [data-js-product-quantity]
       * and then calls the global tiered pricing updater (defined in custom.js).
       */
      const syncAndUpdate = () => {
        const v = parseInt(qty.value, 10) || 1;
        // Keep the "master" quantity in sync
        jQuery('[data-js-product-quantity]').val(v).trigger('change');

        // Let the global pricing logic handle everything else
        if (typeof window.updateTieredPricing === 'function') {
          window.updateTieredPricing();
        }
      };

      qtyMinus.addEventListener('click', (e) => {
        e.preventDefault();

        const current = parseInt(qty.value, 10) || 1;

        if (!qtyMinus.classList.contains('disabled') && current > qtyMin) {
          qty.value = current - 1;
          qtyPlus.classList.remove('disabled');
        }

        if ((parseInt(qty.value, 10) || 1) <= qtyMin) {
          qtyMinus.classList.add('disabled');
        }

        syncAndUpdate();
      });

      qtyPlus.addEventListener('click', (e) => {
        e.preventDefault();

        const current = parseInt(qty.value, 10) || 1;

        if (!qtyPlus.classList.contains('disabled') && current < qtyMax) {
          qty.value = current + 1;
          qtyMinus.classList.remove('disabled');
        }

        if ((parseInt(qty.value, 10) || 1) >= qtyMax) {
          qtyPlus.classList.add('disabled');
        }

        syncAndUpdate();
      });

      // Initial sync on load
      syncAndUpdate();
    }
  }

  if (typeof customElements.get('product-quantityvariant') === 'undefined') {
    customElements.define('product-quantityvariant', ProductQuantity);
  }

}
